/**
 * NOTE: For compatibility across platforms all calls **must** return a
 * `Promise` object!
 */

import * as Platform from '../Platform';
import { Permission } from '../Permissions';
import { BrowserPlayer } from '../Browser/BrowserPlayer';
import { RandomUuidHardwareIdGeneratorMixin } from '../mixins/RandomUuidHardwareIdGeneratorMixin';
import { $ } from '../../../vendor/jquery';
import { sendLoadedPostbackToCms } from './PostbackCms';
import { isUrlQueryPlatform } from '../PlatformCheck';
import { isInsideCms } from '../../Signage/urlOverrides';
import { previewPlayOverlayTemplate } from '../../Display/DisplayTemplate';

/**
 * @constructor
 * @augments BrowserPlayer
 * @mixes RandomUuidHardwareIdGeneratorMixin
 */
function PreviewPlayer() {
    BrowserPlayer.call(this);
    this.addPermission(Permission.PLAY_REACH_VIDEO);
}

PreviewPlayer.prototype = Object.create(BrowserPlayer.prototype);
RandomUuidHardwareIdGeneratorMixin.call(PreviewPlayer.prototype);
PreviewPlayer.prototype.constructor = PreviewPlayer;

/**
 * @inheritDoc
 */
PreviewPlayer.prototype.type = Platform.PREVIEW_PLAYER;

/**
 * @inheritDoc
 */
PreviewPlayer.prototype.name = 'Preview Player';

/**
 * @returns {boolean}
 */
PreviewPlayer.isTheRunningPlatform = function () {
    const thisPlatformIsRunning = isUrlQueryPlatform('Preview');
    if (typeof thisPlatformIsRunning === 'boolean') {
        return thisPlatformIsRunning;
    }

    // use fallback check
    return isInsideCms();
};

/**
 * @inheritDoc
 */
PreviewPlayer.prototype.initializePlatform = async function () {
    await BrowserPlayer.prototype.initializePlatform.call(this);

    sendLoadedPostbackToCms();

    return new Promise(function (resolve) {
        //force the user to click a "play" button to proceed so that user has
        //"interacted" with the iframe this allows videos to autoplay following
        //Google's changes to video autoplay
        var overlay = $(previewPlayOverlayTemplate(undefined));

        overlay.on('click', function () {
            overlay.remove();

            resolve();
        });

        $('body').append(overlay);
    });
};

export { PreviewPlayer };
